import { DetailTurnModalProps } from "./types";
import { GetOneAppointmentResponseService } from "../../../services/TurnServices/Turns.type";
import { Modal } from "../../../components/others/Modal";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import LavorisService from "../../../services/LavorisService";
import { useFetchOne } from "../../../hooks";
import { TagField } from "../../../components/others/TagField";
import {
  MoldeDetails,
  ExamDetails,
  PracticesList,
} from "../AppointmentMetadata";
import { TableActions } from "../../../components/others/TableActions";
import moment from "moment";

const DetailTurnWithDate: React.FC<DetailTurnModalProps> = ({
  closeModal,
  ...modalProps
}) => {
  const rowData = useFetchOne<GetOneAppointmentResponseService>("appointments");

  const moldeName = rowData?.metadata?.molde && rowData?.metadata?.molde?.name.toLowerCase();
  const moldePlantProfessional = moldeName?.includes('medico en planta') && rowData?.status === "Presente en Lavoris";

  const LavorisInstance = LavorisService.getInstance();
  const fileArray = Array.isArray(rowData?.files) ? rowData?.files : [];

  const handleDownload = (fileId: string) => {
    LavorisInstance.FilesService.getAWSTurnFile(fileId);
  };

  if (!rowData)
    return (
      <Modal
        {...modalProps}
        titleStyle="text-2xl text-red-500 font-bold my-4"
        modalContainerStyle="max-w-lg"
      >
        <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
          {" "}
          Cargando...{" "}
        </h1>
      </Modal>
    );

  return (
    <Modal
      {...modalProps}
      titleStyle="text-2xl text-red-500 font-bold my-4"
      modalContainerStyle="max-w-lg"
    >
      <div className="mb-4 max-w-lg">
        <div className="flex gap-10 items-center bg-[#F8F7F7] rounded-lg p-4">
          <div className="relative flex items-center justify-center w-20 h-20 ml-8 bg-white rounded-full shadow-xl">
            <img src="/images/Profile.svg" alt="" />
            <div className="absolute bottom-0 right-0">
              <svg
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              />
            </div>
          </div>
          <div>
            <p>
              <StyledWrapper.ListItemCard>Nombre:</StyledWrapper.ListItemCard>
              {rowData?.patient.name || "---"}
            </p>
            <p>
              <StyledWrapper.ListItemCard>DNI:</StyledWrapper.ListItemCard>
              {rowData?.patient.DNI || "---"}
            </p>
            {/* <p>
              <StyledWrapper.ListItemCard>Cliente:</StyledWrapper.ListItemCard>
              {rowData?.patient?.company?.socialReason ||
                rowData?.patient?.company?.branchOfficeName ||
                "---"}
            </p> */}
            <p>
              <StyledWrapper.ListItemCard>
                Fecha de Nacimiento:
              </StyledWrapper.ListItemCard>
              {rowData?.patient.birthDate || "---"}
            </p>
            <p>
              <StyledWrapper.ListItemCard>Puesto:</StyledWrapper.ListItemCard>
              {rowData?.patient.positionName || "No aplica"}
            </p>
          </div>
        </div>

        {rowData?.metadata.molde ? (
          <div className="flex flex-col max-w-lg">
            <StyledWrapper.ListItem>Molde:</StyledWrapper.ListItem>
            <div className="flex flex-wrap mb-3">
              <TagField className="bg-gray-300 font-bold">
                {rowData.metadata.molde.name || "No corresponde"}
              </TagField>
            </div>
            <MoldeDetails molde={rowData?.metadata.molde} />
          </div>
        ) : null}

        {rowData?.metadata.exam ? (
          <div className="flex flex-col max-w-lg">
            <StyledWrapper.ListItem>Examen:</StyledWrapper.ListItem>
            <div className="flex flex-wrap mb-3">
              <TagField className="bg-gray-300 font-bold">
                {rowData.metadata.exam.name}
              </TagField>
            </div>
            <ExamDetails exam={rowData.metadata.exam} />
          </div>
        ) : null}

        {rowData?.metadata.practices ? (
          <div className="flex flex-col max-w-lg mb-3">
            <StyledWrapper.ListItem>Prácticas:</StyledWrapper.ListItem>
            <PracticesList practices={rowData.metadata.practices} />
            {
              rowData?.metadata?.practices?.some((p: any) => p.managerId === '1026') && (
                <div className="flex flex-col gap-2 mt-2">
                  <span><strong>¿Presenta CM?:</strong> {rowData.has_cm ? 'Si' : 'No'} </span>
                  {
                    rowData.has_cm && (
                      <div className="flex flex-col gap-2 justify-start align-middle">
                        <span><strong>Profesional CM:</strong> {rowData.professional_cm} </span>
                        <span><strong>Matrícula CM:</strong> {rowData.professional_license_cm} </span>
                        <span><strong>Fecha CM:</strong> {moment(rowData.cm_date).format('DD/MM/YYYY')} </span>
                        <span><strong>Días otorgados CM: </strong>{rowData.cm_days} </span>
                      </div>
                    )
                  }
                </div>
              )
            }
          </div>
        ) : null}

        <hr className="my-2" />
        <StyledWrapper.ListItem>
          Fecha y Hora:{" "}
          <span className="font-normal">
            {rowData?.date && rowData?.startTime
              ? `${rowData?.date} - ${rowData?.startTime}hs.`
              : "No corresponde"}
          </span>
        </StyledWrapper.ListItem>
        <hr className="my-2" />
        <StyledWrapper.ListItem>
          <div className="flex flex-wrap gap-3 align-middle justify-start">
            {rowData?.status === 'Ausente' || rowData?.status === 'Eliminado' || rowData?.status === 'Cancelado' ? <TableActions
              type="Time"
              title={rowData?.status === 'Ausente' ? 'No se presentó' : '---'}
              color={'blue'}
              onClick={() => { }}
            /> : <TableActions
              type="Time"
              title={rowData?.tardiness || ''}
              color={rowData?.is_late ? 'red' : 'green'}
              onClick={() => { }}
            />}
            Estado: <span className="font-normal">{moldePlantProfessional ? 'Control en planta' : rowData?.status}</span>
          </div>
        </StyledWrapper.ListItem>
        <hr className="my-2" />
        <StyledWrapper.ListItem>Comentarios:</StyledWrapper.ListItem>
        <p>{rowData?.observations || "Sin comentarios"}</p>
        <hr className="my-2" />
        <StyledWrapper.ListItem>Adjuntos:</StyledWrapper.ListItem>
        {fileArray && fileArray?.length > 0 ? (
          <ul className="list-none space-y-2 mt-2">
            {fileArray?.map((file: { id: string; name?: string }) => (
              <li
                key={file.id}
                className="flex items-center justify-between gap-2 py-2 px-3 bg-gray-50 rounded border border-gray-200"
              >
                <span className="truncate text-sm" title={file.name || file.id}>
                  {file.name || file.id || "Archivo"}
                </span>
                <button
                  type="button"
                  onClick={() => handleDownload(file.id)}
                  className="inline-flex items-center gap-1 px-2 py-1 text-sm font-medium text-white bg-gray-800 rounded hover:bg-gray-700"
                >
                  Descargar
                  <FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500 mt-2">No hay archivos adjuntos</p>
        )}
      </div>
      <div className="flex justify-end">
        <PrimaryButton
          type="button"
          text="Aceptar"
          onClick={closeModal}
          styles="block bg-red-400 text-white font-bold hover:bg-opacity-80 mt-auto w-40"
        />
      </div>
    </Modal>
  );
};

export default DetailTurnWithDate;
